import React from "react";
import { Link } from "react-router-dom";
import styles from "./ErrorScreen.module.css";

import { ReactComponent as DermiLogoIcon } from "./Icons/dermi_logo.svg";

function ErrorScreen() {
  return (
    <div
      className={
        styles["background"] +
        " " +
        "fixed top-0 right-0 bottom-0 left-0 \
         flex flex-col items-center w-full h-full p-2 overflow-scroll"
      }
    >
      <div
        className="flex flex-col-reverse sm:flex-col-reverse md:flex-row items-center justify-between Xbg-red-500
                   w-full min-h-[50rem] md:min-h-[30rem] mt-auto mb-auto"
      >
        <div className="flex flex-col flex-1 items-center justify-between w-full px-5 Xbg-green-500">
          <div className="text-[10rem] font-semibold text-neutral-900">
            404
          </div>
          <div className="text-4xl font-normal text-neutral-900">
            Page Not Found!
          </div>
          <Link
            to={"/"}
            className="flex flex-row items-center justify-center p-5 mt-12
                     bg-neutral-900 hover:bg-neutral-700 active:bg-neutral-800
                       rounded-lg shadow-sm
                       w-full sm:w-full md:w-auto
                       cursor-pointer
                       text-4xl font-normal text-white 
                      "
          >
            Take me Home
          </Link>
        </div>
        {/* Logo Container */}
        <div className="flex flex-col flex-1 items-center justify-center h-96 w-96 md:h-full md:w-full p-5 Xbg-purple-500">
          <DermiLogoIcon className={styles["logo"]} draggable={false} />
        </div>
      </div>
    </div>
  );
}

export default ErrorScreen;
